import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressPremiumDomainSearchAvailabilityV2DomainAvailabilityServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www._base_domain_': [
      {
        srcPath: '/domain-search/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/v2/suggest-domains',
        destPath: '/v2/suggest-domains',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/v2/check-domain-availability',
        destPath: '/v2/check-domain-availability',
      },
      {
        srcPath: '/v2/suggest-domains',
        destPath: '/v2/suggest-domains',
      },
    ],
    'premium._base_domain_': [
      {
        srcPath: '/v2/check-domain-availability',
        destPath: '/v2/check-domain-availability',
      },
      {
        srcPath: '/v2/suggest-domains',
        destPath: '/v2/suggest-domains',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/domain-search/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/premium/domains/v2/check-domain-availability',
        destPath: '/v2/check-domain-availability',
      },
      {
        srcPath: '/premium/domains/v2/suggest-domains',
        destPath: '/v2/suggest-domains',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/v2/check-domain-availability',
        destPath: '/v2/check-domain-availability',
      },
      {
        srcPath: '/v2/suggest-domains',
        destPath: '/v2/suggest-domains',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/v2/check-domain-availability',
        destPath: '/v2/check-domain-availability',
      },
      {
        srcPath: '/v2/suggest-domains',
        destPath: '/v2/suggest-domains',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/v2/check-domain-availability',
        destPath: '/v2/check-domain-availability',
      },
      {
        srcPath: '/v2/suggest-domains',
        destPath: '/v2/suggest-domains',
      },
    ],
    'vibe._base_domain_': [
      {
        srcPath: '/premium/domains/v2/check-domain-availability',
        destPath: '/v2/check-domain-availability',
      },
      {
        srcPath: '/premium/domains/v2/suggest-domains',
        destPath: '/v2/suggest-domains',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/premium/domains/v2/suggest-domains',
        destPath: '/v2/suggest-domains',
      },
      {
        srcPath: '/premium/domains/v2/check-domain-availability',
        destPath: '/v2/check-domain-availability',
      },
    ],
    _: [
      {
        srcPath: '/premium/domains/v2/suggest-domains',
        destPath: '/v2/suggest-domains',
      },
      {
        srcPath: '/premium/domains/v2/check-domain-availability',
        destPath: '/v2/check-domain-availability',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_domains_domain-availability';

/**
 * Checks whether the given domain is available for purchase.
 *
 *
 * You can purchase the specified domain in case the returned
 * `availability.available` boolean is `true`. The domain is already taken
 * when `false` is returned.
 *
 * The `domain` field must include the TLD. For example, `my-new-domain.com`.
 *
 * > __Important:__ This call requires an account level API key and cannot be authenticated with the standard authorization header.
 */
export function checkDomainAvailability(
  payload: object
): RequestOptionsFactory<any> {
  function __checkDomainAvailability({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.premium.domains.v2.availability',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.premium.domain.search.availability.v2.DomainAvailabilityService.CheckDomainAvailability',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressPremiumDomainSearchAvailabilityV2DomainAvailabilityServiceUrl(
        { protoPath: '/v2/check-domain-availability', data: payload, host }
      ),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __checkDomainAvailability;
}
